module.exports = __webpack_public_path__ + "510bda681c9a4b37bf1a92ccddef3525.svg";